import { Component, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { SELECT_OPTION } from '../user-bulk-actions.component';
import { TabChange, UserBulkActionsService, UserTabAccessInfo } from '../user-bulk-actions.service';

@Component({
  selector: 'app-bulk-tab-access-change',
  templateUrl: './bulk-tab-access-change.component.html',
  styleUrls: ['./bulk-tab-access-change.component.scss'],
})
export class BulkTabAccessChangeComponent implements OnInit {
  dropdownOptions = [
    {
      id: SELECT_OPTION.DONT_UPDATE,
      name: "Don't Update",
      key: 'USERS.BULK_UPDATE_SETTINGS.DONT_UPDATE',
    },
    {
      id: SELECT_OPTION.GIVE_ACCESS,
      name: 'Turn On',
      key: 'USERS.BULK_UPDATE_SETTINGS.TURN_ON',
    },
    {
      id: SELECT_OPTION.REMOVE_ACCESS,
      name: 'Turn Off',
      key: 'USERS.BULK_UPDATE_SETTINGS.TURN_OFF',
    },
  ];

  data: UserTabAccessInfo;
  tabsGivenAccess: TabChange[] = [];
  tabsRemovedAccess: TabChange[] = [];

  constructor(private userBulkActionsService: UserBulkActionsService) {}

  ngOnInit(): void {
    this.data = this.userBulkActionsService.getUserTabAccessInfo();
  }

  getClass(tabId: string): string {
    if (this.tabsGivenAccess.find((tab) => tab.id === tabId)) {
      return 'give-access';
    }
    if (this.tabsRemovedAccess.find((tab) => tab.id === tabId)) {
      return 'remove-access';
    }
    return '';
  }

  selectChange(event: MatSelectChange, id: string, name: string): void {
    switch (event.value) {
      case SELECT_OPTION.DONT_UPDATE:
        if (this.tabsGivenAccess.find((tab) => tab.id === id)) {
          this.tabsGivenAccess = this.tabsGivenAccess.filter((tab) => tab.id !== id);
        }
        if (this.tabsRemovedAccess.find((tab) => tab.id === id)) {
          this.tabsRemovedAccess = this.tabsRemovedAccess.filter((tab) => tab.id !== id);
        }
        break;
      case SELECT_OPTION.GIVE_ACCESS:
        if (!this.tabsGivenAccess.find((tab) => tab.id === id)) {
          this.tabsGivenAccess.push({
            name,
            id,
          });
        }
        if (this.tabsRemovedAccess.find((tab) => tab.id === id)) {
          this.tabsRemovedAccess = this.tabsRemovedAccess.filter((tab) => tab.id !== id);
        }
        break;
      case SELECT_OPTION.REMOVE_ACCESS:
        if (!this.tabsRemovedAccess.find((tab) => tab.id === id)) {
          this.tabsRemovedAccess.push({
            name,
            id,
          });
        }
        if (this.tabsGivenAccess.find((tab) => tab.id === id)) {
          this.tabsGivenAccess = this.tabsGivenAccess.filter((tab) => tab.id !== id);
        }
    }
    this.userBulkActionsService.setTabAccess(this.tabsGivenAccess, this.tabsRemovedAccess);
  }
}
